<template>
<div class="dw-page__redo-wrap">
	<div class="dw-page__redo-side dw-page__redo-input">
		<form action="" class="item-redo"  v-on:submit.prevent="scan">
				<h3 class="item-redo__title">REDO LOGS</h3>
				<label for="" class="item-redo__label">serial Input</label>
				<textarea
					
					class="item-redo__input"
					v-model="item_serial"
					name="item_serial"
					placeholder="One item barcode per line"
					
				></textarea>
				
			</form>
			
		<input
					type="submit"
					value="SUBMIT"
					class="btn btn--blue item-redo__submit"
					v-on:click="submitredo"
					
				/>
	</div>


</div>

	
</template>

<script>
import Vue from "vue";
import axios from "axios";

// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);


export default Vue.extend({
	name: "ItemRedoLog",
	components: {},
	data() {
		return {
			redoList: []
		}
	},
	methods: {
		submitredo: function(e) {
		
			let loader = this.$loading.show({
                  // Optional parameters
                  container: null,
                  canCancel: false,
                  
                });
			
			alert(this.item_serial);
			
			
			//axios.post("https://new.colorwayrb.com/backend/testpo.php?sessionid=" + localStorage.getItem("sessionid"), this.redoList)
			axios.post("https://new.colorwayrb.com/backend/testpo.php?sessionid=" + localStorage.getItem("sessionid"), {
				
				item_serial: this.item_serial
				
				
			})
					.then(({ data }) => {
						
						loader.hide();
						location.href = 'https://new.colorwayrb.com/backend/' + data.returnurl;
						
						
						
					})
					.catch(err => {
						
						alert("PROBLEM!" + err);
					});
		}
	},
});
</script>

<style lang="scss" scoped>
.item-redo {
	border: 1px solid $border-color;
	border-radius: 5px;
	width: 420px;

	&__title {
		background-color: $color7;
		width: calc(100% - 1px);
		text-align: center;
		border-radius: 5px;
		font-size: 22px;
		padding: 5px 0;

		border: 1px solid $border-color;
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0;
	}

	&__label {
		text-transform: capitalize;
		text-align: center;
		font-weight: 500;
		padding: 20px 0;
		font-size: 18px;
		margin: 0 auto;
		display: block;
	}

	&__input {
		border-radius: 10px;
		text-align: center;
		display: block;
		padding: 10px 0;
		margin: 0 auto;
		width: 310px;
		border: none;
	}

	&__submit {
		margin: 20px auto 30px;
		border-radius: 10px;
		padding: 8px 50px;
		display: block;
	}
}

.redo-logs {
	width: 500px;
	height: 500px;
	border: 1px solid $border-color;
	border-radius: 5px;

	&__title {
		border: 1px solid $border-color;
		background-color: $color7;
		text-align: center;
		font-size: 22px;
		padding: 5px 0;
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
	}

	&__container {
		overflow-y: scroll;
		height: 463px;
	}
}

.redo-table {
	margin: 20px auto;

	th,
	td {
		border: 1px solid $border-color;
		text-align: center;
	}

	th {
		background-color: lighten($color7, 12%);
		padding: 5px 0;
		font-weight: 600;
		font-size: 14px;

		&:nth-child(1) {
			width: 200px;
		}

		&:nth-child(2) {
			width: 125px;
		}

		&:nth-child(3) {
			width: 90px;
		}
	}

	td {
		font-size: 14px;
		padding: 5px;

		&:last-child {
			padding: 0;
		}
	}

	&__btn-wrap {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	&__btn {
		// box-shadow: 1px 1px 1px $border-color;
		// transition: background-color $btn-transition linear;
		// background-color: $color6;
		// color: $color1;
		// cursor: pointer;
		// border: none;
		border-radius: 50%;
		height: 20px;
		width: 25px;

		// &:hover {
		// 	background-color: $text-highlighter;
		// }
	}
}

.dw-page__redo-side {
    padding: 0 30px;
}
</style>